import * as React from "react";
import { QrCode } from "../../modules/PaymentMethodsList/modules/QrCode/layout/modules/PaymentMethodsList/modules/QrCode/layout/QrCode.js";
const useRenderQrForm = () => {
  const renderQrForm = React.useCallback(
    ({
      paymentMethodType,
      logoUrl,
      orderId,
      qrPaymentConfig,
      orderToken,
      handleRefreshQrCode,
      cart,
      refetch,
      selfUrl,
      paymentFlow,
      getNewCart
    }) => {
      return /* @__PURE__ */ React.createElement(
        QrCode,
        {
          logoSettings: {
            alt: paymentMethodType,
            url: logoUrl
          },
          paymentFlow,
          paymentMethodType,
          orderId,
          paymentResponse: qrPaymentConfig,
          orderToken,
          onQrCodeRefresh: handleRefreshQrCode,
          selfUrl,
          refetch,
          cart,
          getNewCart
        }
      );
    },
    []
  );
  return React.useMemo(() => [renderQrForm], [renderQrForm]);
};
export {
  useRenderQrForm
};
//# sourceMappingURL=use-render-qr-form.js.map
